import { Box, Grid, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { getKeyFromText } from "../../../utils/Utilities";

const OtherRelations = (props) => {
  const { t } = useTranslation();
  const { list, click } = props;

  let leftArray = [];
  let rightArray = [];

  for (let i = 0; i < list.length; i++) {
    const element = list[i];

    if (
      t(getKeyFromText(element.relationship)) === t("relationship-11") ||
      element.relationship === "Pet" ||
      element.relationship === "Haustier"
    ) {
      leftArray.push(element);
    } else {
      rightArray.push(element);
    }
  }

  const style = {
    position: "absolute",
    bottom: "10px",
    right: 0,
    width: "15px",
    cursor: "pointer",
  };

  const typoStyle = { fontSize: "15px" };

  return (
    <Grid container>
      <Grid
        item
        lg={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {leftArray.map((item, index) => (
          <Box className="left" key={index}>
            <Box
              component="div"
              sx={{
                position: "relative",
                marginTop: "0.8rem",
                width: "50px",
              }}
            >
              <img
                src={item.profilePicture}
                style={{
                  borderRadius: "50%",
                }}
                alt="pet"
                className={`user-image ${item.shadow && "icon-box-shadow"}`}
              />
              <img
                src={item.edit}
                alt="edit"
                style={style}
                onClick={() => click(item, "edit")}
              />
            </Box>
            <Tooltip title={item.firstName}>
              <p className="text-eclipse" style={typoStyle}>
                {item.firstName}
              </p>
            </Tooltip>
          </Box>
        ))}
      </Grid>
      <Grid
        item
        lg={6}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {rightArray.map((item, index) => (
          <React.Fragment key={index}>
            <Box
              component="div"
              sx={{
                position: "relative",
                marginTop: "0.8rem",
                width: "50px",
              }}
            >
              <img
                src={item.profilePicture}
                alt="friend"
                style={{
                  borderRadius: "50%",
                }}
                className={`user-image ${item.shadow && "icon-box-shadow"}`}
              />
              <img
                src={item.edit}
                alt="edit"
                style={style}
                onClick={() => click(item, "edit")}
              />
              {item.isAliveImage && (
                <img
                  src={item.isAliveImage}
                  alt="edit"
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: 0,
                    width: "15px",
                  }}
                />
              )}
            </Box>

            <Tooltip title={item.firstName} followCursor>
              <p className="text-eclipse" style={typoStyle}>
                {item.firstName}
              </p>
            </Tooltip>
            <Tooltip title={item.lastName} followCursor>
              <p className="text-eclipse" style={typoStyle}>
                {item.lastName}
              </p>
            </Tooltip>
          </React.Fragment>
        ))}
      </Grid>
    </Grid>
  );
};

export default OtherRelations;
